import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, deepStringFind, Enums, inject, subUnitsOfTime, toArray, toKeyArray } from 'Mri.Web.Common';
import * as React from 'react';
import { BsFolder } from '@react-icons/all-files/bs/BsFolder';
import { Collapse } from 'reactstrap';
import { DisplayEventProfileItem } from './DisplayEventProfileItem';
import { DisplayEventProfileStore } from './DisplayEventProfileStore';

export interface IEventProfileListProps {
    readonly title: string;
    readonly forceOpen: boolean;
    readonly displayEventProfiles: Mri.DisplayEventProfiles.DisplayEventProfile[];
}

@autoinject
@observer
export class EventProfileFolderList extends React.Component<IEventProfileListProps> {
    public render() {
        const collapsed = this.collapsed && !this.props.forceOpen;
        return (
            <>
                <tr className="foldering-system-row">
                    <td colSpan={9}>
                        <a onClick={this.toggleCollapse} className="btn btn-link py-0">
                            <em>{collapsed ? <BsFolder /> : <BsFolder />}</em>
                            <b>&nbsp; {this.props.title}</b>
                        </a>
                    </td>
                </tr>
                {!collapsed &&
                    this.props.displayEventProfiles?.map(e => (
                        <DisplayEventProfileItem key={e.displayEventProfileGuid} displayEventProfile={e} />
                    ))}
            </>
        );
    }

    @bind
    @action
    private toggleCollapse() {
        this.collapsed = !this.collapsed;
    }

    @observable private collapsed = true;
}
